import { render, staticRenderFns } from "./MainWrapper.vue?vue&type=template&id=d8dc1a70&"
import script from "./MainWrapper.vue?vue&type=script&lang=js&"
export * from "./MainWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports